module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAS0lEQVQ4jWNgGGjAyMDAwLBp06b/5Gj28/NjZIFxzM1MSdJ88tRpBgYGBgYmcmxGBsPAAEYGBgaGK4q2ZMWCzv3DjAPvhYE3YBgAABvbCxf3m4YWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/PL.png
// module id = 1242
// module chunks = 0